'use client';
import { useState, useCallback } from 'react';
import { useWindowEvent } from '@s7/hooks';
import { ceil } from '@s7/utils';

/**
 * Хук для определения отображения хедера
 * TODO: предусмотреть различные стратегии отображения хедера: статичный, со скрытие при прокрутке, скрыт
 * @param headerHeight - высота Хедера
 * @returns boolean - показывается ли Хедер
 */ const useShowHeader = (headerHeight)=>{
    const [showHeader, setShowHeader] = useState(true);
    let lastScrollY = 0;
    const controlNavbar = useCallback(()=>{
        const scrollY = ceil(window.scrollY);
        const paddingByWindowWidth = headerHeight;
        if (/**
             * Скрытие хедера при условии того что позиция прокрутки находится
             * вне области верхнего padding страницы
             */ scrollY > paddingByWindowWidth && /**
             * Скрытие хедера при условии того что позиция прокрутки больше
             * по значению чем прошлая позиция
             */ scrollY > lastScrollY && /**
             * Скрытие хедера при условии того что значения прокрутки являются валидными
             */ scrollY !== 0 && lastScrollY !== 0) {
            setShowHeader(false);
        }
        if (/**
             * Отображение хедера при прокрутке с условием того что позиция прокрутки находится
             * вне области верхнего padding страницы и overflow страницы не равен hidden
             */ scrollY < lastScrollY && lastScrollY > paddingByWindowWidth && scrollY !== 0 || /**
             * Отображение хедера при прокрутке с условием того что позиция прокрутки находится
             * в начале страницы с проверкой того что прошлая позиция находится в области
             * верхнего padding страницы
             */ scrollY === 0 && lastScrollY <= paddingByWindowWidth || /**
             * Отображение хедера при прокрутке с условием того что позиция прокрутки находится
             * в промежутке от начала страницы до нижней границы верхнего padding страницы
             */ scrollY < paddingByWindowWidth && lastScrollY > 0 && scrollY >= 0) {
            setShowHeader(true);
        }
        lastScrollY = scrollY;
    }, [
        lastScrollY
    ]);
    useWindowEvent('scroll', controlNavbar);
    return showHeader;
};

export { useShowHeader };
//# sourceMappingURL=useShowHeader.js.map
